import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/TMA.gif'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_2 = { id: "footer" }
const _hoisted_3 = { id: "footer2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Powered by ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.avalonwebdesign.co.za/",
  target: "_blank"
}, "Avalon Web Design", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://www.tma-sa.com/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "tma"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createTextVNode(" © Copyright " + _toDisplayString((new Date).getFullYear()) + ". All rights reserved ", 1),
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _hoisted_7
      ])
    ])
  ], 64))
}